import React, {useEffect, useState} from 'react';
import {Box, makeStyles, Tab, Tabs, useTheme} from "@material-ui/core";
import PropTypes from "prop-types";
import {IoIosClose} from "react-icons/io";
import {useSelector} from "react-redux";
import {TextLink, Loader} from "../../../components";
import axios from "axios";
import {adminToken} from "../../../helper";
import styles from "../../../components/Table/styles.module.scss";
import { AWS_ROUTING, AWS_SERVER_APIS } from "configurations";

function getModalStyle() {
    const top = 50
    const left = 50

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}


const useStyles = makeStyles((theme) => ({
    indicator: {
        backgroundColor: "#6CD7BB"
    }
}))


const initialFilterState = {
    service_date: "",
    service_time: ""
};

function UpdateServiceDatePopup({tableRows, handleCloseSDT, currentSubID}) {
    const data = tableRows.filter((item)=>{
            return item?.id == currentSubID
        })
    console.log(JSON.stringify(data));
    const {user} = useSelector(state => ({
            user: state.user
        }));
        
    const [filterState, setFilterState] = useState({service_date:data[0].serviceDate, service_time:data[0].serviceTime});

    useEffect(() => {
        
    }, [])

    const [modalStyle] = useState(getModalStyle);
    const [spLoader, setSpLoader] = useState(false);
    
    const classes = useStyles()

    
    const loading = useSelector(state => state.loading);

    return (
        <div style={modalStyle} className={'modal-paper-small update_service_date'}>
            <div className={'modal-top-bar'}>
                <IoIosClose
                    size={20}
                    className={'modal-close'}
                    onClick={handleCloseSDT}
                />
            </div>
            <div className={'modal-header'}>
                <h5>Update Service Date & Time</h5>
            </div>
            <div className={'modal-body'}>
                
                <table width="100%">
                    <tr>
                        <td>Service Date</td>
                        <td>:</td>
                        <td><input type="date" onChange={e =>
                                setFilterState({...filterState, [e.target.name]: e.target.value})
                            } name="service_date" value={filterState?.service_date}/></td>
                    </tr>
                    <tr>
                        <td>Service Time</td>
                        <td>:</td>
                        <td><input type="time" onChange={e =>
                                setFilterState({...filterState, [e.target.name]: e.target.value})
                            } name="service_time" value={filterState?.service_time}/></td>
                    </tr>
                </table>
                <button className='btn btn-primary' onClick={(status) => {
                    setSpLoader(true);
                adminToken().then(token =>
                    axios.post(`${AWS_SERVER_APIS}/updateservicedatetime`, {
                        subscription_id: currentSubID,
                        service_date: filterState.service_date,
                        service_time: filterState.service_time,
                    }, {headers: {Authorization: `Bearer ${token}`}})
                        .then(res => {
                            if(res.data.type == 'error'){
                                alert('Error: '+res.data.message);
                            }else{
                                alert('Service Date And Time Updated Successfull!');
                                handleCloseSDT()
                                document.querySelector('.search_commision').click();
                            }
                            setSpLoader(false);
                        })
                );
                }}>Update</button> {spLoader ? (
                    <div className={styles.loading__container}>
                      <Loader />
                    </div>
                  ) : null}
            </div>
        </div>
    );
}

export default UpdateServiceDatePopup;
